import { useAuth } from '@/lib/config/auth-provider'

/**
 * Org kill switch for study creation (`createStudy`).
 * Missing means on, matching Sidebar and backend workspace override semantics.
 */
export function useCreateStudyEnabled(): boolean {
  const { user } = useAuth()
  return user?.featureFlags?.createStudy !== false
}
